import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { isNumber } from '@grandvisionhq/utils';
import '../../../../../../context/actions.js';
import '../../../../../../context/reducer.js';
import { useProductData } from '../../../../../../context/product-context-hooks.js';
import '../../../../../../context/ProductContext.js';
import '../../../../../../context/CmsContext.js';
import '../../../../../../types/product.js';
import { isSubscriptionPurchase, isSinglePurchase } from '../../../../../../types/typeguards.js';
import '@grandvisionhq/common';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/frk-routing';
import { SinglePurchasePriceCaption } from '../../../../components/CTAs/components/SinglePurchasePriceCaption.js';
import { SubscriptionDailyIntervalPriceCaption } from '../../../../components/CTAs/components/SubscriptionDailyIntervalPriceCaption.js';
import { useSolutionsEcommContext } from '../../../context/SolutionsEcommContext.js';

const SolutionsCTACaption = ()=>{
    const { getLabel  } = useIntl();
    const { displayPrice , selectedPurchaseType  } = useProductData();
    const { state  } = useSolutionsEcommContext();
    const { subscriptionPurchaseConfigurations , quantity  } = state.configurations;
    const { deliveryInterval  } = subscriptionPurchaseConfigurations;
    var _discountedPrice;
    const unitPrice = (_discountedPrice = displayPrice.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : displayPrice.originalPrice;
    const totalPrice = quantity * unitPrice;
    const addToCartLabel = getLabel('products.solutions.addToBasket');
    if (isSubscriptionPurchase(selectedPurchaseType) && isNumber(totalPrice) && !!deliveryInterval) {
        return /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body-head"
        }, addToCartLabel, /*#__PURE__*/ React.createElement(SubscriptionDailyIntervalPriceCaption, {
            isCentAmount: false,
            price: totalPrice,
            priceInterval: deliveryInterval
        }));
    }
    if (isSinglePurchase(selectedPurchaseType) && isNumber(totalPrice) && quantity > 1) {
        return /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body-head"
        }, addToCartLabel, /*#__PURE__*/ React.createElement(SinglePurchasePriceCaption, {
            isCentAmount: false,
            price: totalPrice
        }));
    }
    return /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body-head"
    }, addToCartLabel);
};

export { SolutionsCTACaption };
//# sourceMappingURL=SolutionsCTACaption.js.map
